import React from "react";
import "./FinancialTable.less";
import { checkNegative } from "../../../../utils/generic";
import _ from "lodash";
import { Tooltip } from "@material-ui/core";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

class FinancialTable extends React.Component {
  constructor() {
    super();
    this.state = {
      dataList: [],
      datacenterList: [],
      siteProfileList: []
    };
  }

  componentDidMount() {
    this.setListData();
  }

  componentWillReceiveProps(newProps) {
    if (
      this.props.listData !== newProps.listData ||
      this.props.datacenterList !== newProps.datacenterList ||
      this.props.siteProfileList !== newProps.siteProfileList ||
      this.props.startDate !== newProps.startDate
    ) {
      this.setState({
        dataList: newProps.listData,
        datacenterList: newProps.datacenterList,
        siteProfileList: newProps.siteProfileList
      });
    }
  }

  /** set data */
  setListData() {
    this.setState({
      dataList: this.props.listData,
      datacenterList: this.props.datacenterList,
      siteProfileList: this.props.siteProfileList
    });
  }
  search(nameKey, myArray) {
    if (myArray != undefined) {
      for (let i = 0; i < myArray.length; i++) {
        if (myArray[i].dwPropertyId == nameKey) {
          return myArray[i].name;
        }
      }
    }
  }

  /** Capacity search */
  _searchCapacity(nameKey, propertyKey, myArray, onlyData = false) {
    if (myArray != undefined) {
      const dataSource = (myArray || []).filter(
        x => x.AttributeName == nameKey && x.DwPropertyId == propertyKey
      );
      if (dataSource.length == 0) {
        if (onlyData) return 0;
        return "-";
      }
      for (let i = 0; i < myArray.length; i++) {
        if (
          myArray[i].AttributeName == nameKey &&
          myArray[i].DwPropertyId == propertyKey
        ) {
          return myArray[i].Power !== null
            ? onlyData
              ? parseFloat(myArray[i].Power)
              : parseFloat(myArray[i].Power).toLocaleString()
            : onlyData
            ? 0
            : "-";
        }
      }
    }
    return 0;
  }

  /** Group by functionality */
  groupBy(data) {
    const groupData = _.chain(data)
      .groupBy(x => x[0].productType)
      .map(function(v) {
        return {
          key: v[0][0].productType,
          dataList: v
        };
      })
      .value();

    const { siteProfileList } = this.state;
    for (let i = 0; i < groupData.length; i++) {
      const total = {
        MTDBudget: 0,
        MTDActual: 0,
        MTDVarianceAmt: 0,
        MTDVariancePerct: 0,
        YTDBudget: 0,
        YTDActual: 0,
        YTDVarianceAmt: 0,
        YTDVariancePerct: 0,
        CashOnHand: 0,
        InstalledKw: 0,
        LeasedCapacity: 0
      };

      groupData[i].dataList.forEach(item => {
        total.MTDBudget += parseFloat(
          (item.find(x => x.attributeType == "MTDBudget") || {}).attributeValue
        );
        total.YTDBudget += parseFloat(
          (item.find(x => x.attributeType == "YTDBudget") || {}).attributeValue
        );
        total.MTDActual += parseFloat(
          (item.find(x => x.attributeType == "MTDActual") || {}).attributeValue
        );
        total.YTDActual += parseFloat(
          (item.find(x => x.attributeType == "YTDActual") || {}).attributeValue
        );
        total.CashOnHand += parseFloat(
          (item.find(x => x.attributeType == "CashOnHand") || {}).attributeValue
        );
        const t =
          this._searchCapacity(
            "Total Capacity",
            item[0].propertyKey,
            siteProfileList,
            true
          ) || 0;

        total.InstalledKw += parseFloat(isNaN(t) ? 0 : t);
        const lc =
          this._searchCapacity(
            "Leased Capacity",
            item[0].propertyKey,
            siteProfileList,
            true
          ) || 0;

        total.LeasedCapacity += parseFloat(isNaN(lc) ? 0 : lc);
      });
      total.MTDVarianceAmt = total.MTDActual - total.MTDBudget;
      total.YTDVarianceAmt = total.YTDActual - total.YTDBudget;
      total.MTDVariancePerct = (total.MTDVarianceAmt / total.MTDBudget) * 100;
      total.YTDVariancePerct = (total.YTDVarianceAmt / total.YTDBudget) * 100;
      groupData[i] = { ...groupData[i], ...total };
    }
    return groupData;
  }

  /** Return icon */
  getIcon = id => {
    const dataList = this.state.collapse || [];

    return dataList.find(x => x.key === id)?.isVisible || false;
  };

  /** Set icon */
  setIcon = id => {
    const { collapse } = this.state;
    let dataList = collapse || [];
    const value = dataList.find(x => x.key === id)?.isVisible || false;
    dataList = dataList.filter(x => x.key !== id);
    const obj = { key: id, isVisible: !value };
    dataList.push(obj);
    this.setState({ collapse: dataList });
  };

  render() {
    const total = {
      MTDBudget: 0,
      MTDActual: 0,
      MTDVarianceAmt: 0,
      MTDVariancePerct: 0,
      YTDBudget: 0,
      YTDActual: 0,
      YTDVarianceAmt: 0,
      YTDVariancePerct: 0,
      CashOnHand: 0,
      InstalledKw: 0,
      LeasedCapacity: 0
    };

    const { dataList, siteProfileList, datacenterList } = this.state;
    const { PropertyDetailViewSection, getPropertyDetail } = this.props;
    dataList.forEach(item => {
      total.MTDBudget += parseFloat(
        (item.find(x => x.attributeType == "MTDBudget") || {}).attributeValue
      );
      total.YTDBudget += parseFloat(
        (item.find(x => x.attributeType == "YTDBudget") || {}).attributeValue
      );
      total.MTDActual += parseFloat(
        (item.find(x => x.attributeType == "MTDActual") || {}).attributeValue
      );
      total.YTDActual += parseFloat(
        (item.find(x => x.attributeType == "YTDActual") || {}).attributeValue
      );
      total.CashOnHand += parseFloat(
        (item.find(x => x.attributeType == "CashOnHand") || {}).attributeValue
      );
      const t =
        this._searchCapacity(
          "Total Capacity",
          item[0].propertyKey,
          siteProfileList,
          true
        ) || 0;

      total.InstalledKw += parseFloat(isNaN(t) ? 0 : t);
      const lc =
        this._searchCapacity(
          "Leased Capacity",
          item[0].propertyKey,
          siteProfileList,
          true
        ) || 0;

      total.LeasedCapacity += parseFloat(isNaN(lc) ? 0 : lc);
    });
    total.MTDVarianceAmt = total.MTDActual - total.MTDBudget;
    total.YTDVarianceAmt = total.YTDActual - total.YTDBudget;
    total.MTDVariancePerct = (total.MTDVarianceAmt / total.MTDBudget) * 100;
    total.YTDVariancePerct = (total.YTDVarianceAmt / total.YTDBudget) * 100;
    const groupData = this.groupBy(JSON.parse(JSON.stringify([...dataList])));
    // dataList.forEach(x => {
    // 	if (
    // 		productType.toLowerCase().trim() ==
    // 		(x[0].productType || "").toLowerCase().trim()
    // 	) {
    // 		x[0].productType = "";
    // 		x[0].propertyCount = "";
    // 	} else {
    // 		productType = x[0].productType;
    // 		x[0].propertyCount = productByCount[x[0].productType];
    // 	}
    // });
    return (
      <div>
        <table className={"financial-table"}>
          <thead>
            <tr
              className={"blue-custom-title"}
              style={{ borderTop: "3px solid #FFFFFF" }}
            >
              <th colSpan={3} />
              <th colSpan={8} className={" border-left  border-right"}>
                {"NOI\r"}
              </th>
              <th colSpan={3} />
            </tr>
            <tr
              className={"blue-custom-title"}
              style={{ borderTop: "3px solid #FFFFFF" }}
            >
              <th className={"right-align"} style={{ paddingRight: "10px" }} />
              <th className={"right-align"} style={{ paddingRight: "10px" }} />
              <th className={"right-align"} style={{ paddingRight: "10px" }} />
              <th colSpan={2} className={"border-left"}>
                {"Budgeted ($)\r"}
              </th>
              <th colSpan={2}>{"Actual ($)"}</th>
              <th colSpan={2}>{"Variance ($)"}</th>
              <th colSpan={2} className={"border-right"}>
                {"Variance (%)\r"}
              </th>
              <th colSpan={3}> </th>
            </tr>
            <tr
              className={"blue-custom-title"}
              style={{ borderTop: "3px solid #FFFFFF" }}
            >
              <th />
              <th>{"Product Type"}</th>
              <th>{"Datacenter"}</th>
              <th className={"border-left"}>{"MTD"}</th>
              <th className={""}>{"YTD"}</th>
              <th className={""}>{"MTD"}</th>
              <th className={""}>{"YTD"}</th>
              <th className={""}>{"MTD"}</th>
              <th className={""}>{"YTD"}</th>
              <th className={""}>{"MTD"}</th>
              <th className={"border-right"}>{"YTD"}</th>
              <th className={"right-align"}>{"Cash On Hand ($)"}</th>
              <th className={"right-align"}>{"Installed Capacity (kW) "}</th>
              <th className={"right-align"}>{"Leased Capacity (kW)"}</th>
            </tr>
          </thead>
          <tbody>
            {groupData.map((dataList, ind) => (
              <>
                <tr key={"FinanceList" + ind}>
                  <td className={"bg-dark"}>
                    {this.getIcon(dataList.key) == true ? (
                      <Tooltip title={"Collapse"}>
                        <ArrowDropUpIcon
                          onClick={() => this.setIcon(dataList.key)}
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip title={"Expand "}>
                        <ArrowDropDownIcon
                          onClick={() => this.setIcon(dataList.key)}
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    )}
                  </td>
                  <td className={"w-15 border-right-dark bg-dark border-bottom pointer text-bold"}>
                    {dataList.key + "(" + dataList.dataList.length + ")"}
                  </td>

                  <td className={"w-20 border-right-dark bg-dark border-bottom pointer text-bold"} />

                  <td className={"w-5 right-align text-bold"}>
                    {checkNegative(dataList["MTDBudget"] || 0).toLocaleString()}
                  </td>
                  <td className={"w-5 right-align text-bold"}>
                    {checkNegative(dataList["YTDBudget"] || 0).toLocaleString()}
                  </td>
                  <td className={"w-5 border-left right-align text-bold"}>
                    {checkNegative(dataList["MTDActual"] || 0).toLocaleString()}
                  </td>
                  <td className={"w-5 right-align text-bold"}>
                    {checkNegative(dataList["YTDActual"] || 0).toLocaleString()}
                  </td>
                  <td className={"w-5 border-left right-align text-bold"}>
                    {checkNegative(
                      dataList["MTDVarianceAmt"] || 0
                    ).toLocaleString()}
                  </td>
                  <td className={"w-5 right-align text-bold"}>
                    {checkNegative(
                      dataList["YTDVarianceAmt"] || 0
                    ).toLocaleString()}
                  </td>
                  <td className={"w-5 border-left right-align text-bold"}>
                    {checkNegative(
                      dataList["MTDVariancePerct"] || 0,
                      false
                    ).toLocaleString()}
                  </td>
                  <td className={"w-5 right-align border-right-dark text-bold"}>
                    {checkNegative(
                      dataList["YTDVariancePerct"] || 0,
                      false
                    ).toLocaleString()}
                  </td>
                  <td className={"w-10 border-left  border-bottom right-align text-bold"}>
                    {checkNegative(
                      dataList["CashOnHand"] || 0
                    ).toLocaleString()}
                  </td>
                  <td className={"w-10 border-bottom border-left right-align text-bold"}>
                    {/* {this._searchCapacity(
											"Total Capacity",
											item[0].propertyKey,
											siteProfileList
										)} */}
                  </td>
                  <td className={"w-10  border-bottom border-left right-align text-bold"}>
                    {/* {this._searchCapacity(
											"Leased Capacity",
											item[0].propertyKey,
											siteProfileList
										)} */}
                  </td>
                </tr>
                {this.getIcon(dataList.key) == true &&
                  (dataList["dataList"] || []).map((item, index) => (
                    <tr key={"FinanceListChild" + index}>
                      <td
                        colSpan={2}
                        className={"border-right-dark bg-dark border-bottom pointer"}
                      >
                        {/* {item[0].propertyCount && item[0].productType
												? `${item[0].productType} (${item[0].propertyCount})`
												: item[0].productType || ""} */}
                      </td>

                      {PropertyDetailViewSection ? (
                        <>
                          <td
                            className={"w-20 border-right-dark bg-dark border-bottom pointer"}
                            onClick={() =>
                              getPropertyDetail(item[0].propertyKey)}
                          >
                            {this.search(item[0].propertyKey, datacenterList)}
                          </td>
                        </>
                      ) : (
                        <>
                          <td className={"w-20 border-right-dark bg-dark border-bottom pointer"}>
                            {this.search(item[0].propertyKey, datacenterList)}
                          </td>
                        </>
                      )}

                      <td className={"w-5 right-align"}>
                        {checkNegative(
                          (item.find(x => x.attributeType == "MTDBudget") || {})
                            .attributeValue
                        ).toLocaleString()}
                      </td>
                      <td className={"w-5 right-align"}>
                        {checkNegative(
                          (item.find(x => x.attributeType == "YTDBudget") || {})
                            .attributeValue
                        ).toLocaleString()}
                      </td>
                      <td className={"w-5 border-left right-align"}>
                        {checkNegative(
                          (item.find(x => x.attributeType == "MTDActual") || {})
                            .attributeValue
                        ).toLocaleString()}
                      </td>
                      <td className={"w-5 right-align"}>
                        {checkNegative(
                          (item.find(x => x.attributeType == "YTDActual") || {})
                            .attributeValue
                        ).toLocaleString()}
                      </td>
                      <td className={"w-5 border-left right-align"}>
                        {checkNegative(
                          (
                            item.find(
                              x => x.attributeType == "MTDVarianceAmt"
                            ) || {}
                          ).attributeValue
                        ).toLocaleString()}
                      </td>
                      <td className={"w-5 right-align"}>
                        {checkNegative(
                          (
                            item.find(
                              x => x.attributeType == "YTDVarianceAmt"
                            ) || {}
                          ).attributeValue
                        ).toLocaleString()}
                      </td>
                      <td className={"w-5 border-left right-align"}>
                        {checkNegative(
                          (
                            item.find(
                              x => x.attributeType == "MTDVariancePerct"
                            ) || {}
                          ).attributeValue,
                          false
                        ).toLocaleString()}
                      </td>
                      <td className={"w-5 right-align border-right-dark"}>
                        {checkNegative(
                          (
                            item.find(
                              x => x.attributeType == "YTDVariancePerct"
                            ) || {}
                          ).attributeValue,
                          false
                        ).toLocaleString()}
                      </td>
                      <td className={"w-10 border-left  border-bottom right-align"}>
                        {checkNegative(
                          (
                            item.find(x => x.attributeType == "CashOnHand") ||
                            {}
                          ).attributeValue
                        ).toLocaleString()}
                      </td>
                      <td className={"w-10 border-bottom border-left right-align"}>
                        {this._searchCapacity(
                          "Total Capacity",
                          item[0].propertyKey,
                          siteProfileList
                        )}
                      </td>
                      <td className={"w-10  border-bottom border-left right-align"}>
                        {this._searchCapacity(
                          "Leased Capacity",
                          item[0].propertyKey,
                          siteProfileList
                        )}
                      </td>
                    </tr>
                  ))}
              </>
            ))}
            <tr>
              <td
                colSpan={3}
                className={"border-right-dark bg-dark border-bottom pointer text-bold"}
              >
                {"Total\r"}
              </td>
              <td className={"w-5 right-align text-bold"}>
                {checkNegative(total.MTDBudget).toLocaleString()}
              </td>
              <td className={"w-5 right-align text-bold"}>
                {checkNegative(total.YTDBudget).toLocaleString()}
              </td>
              <td className={"w-5 border-left right-align text-bold"}>
                {checkNegative(total.MTDActual).toLocaleString()}
              </td>
              <td className={"w-5 right-align text-bold"}>
                {checkNegative(total.YTDActual).toLocaleString()}
              </td>
              <td className={"w-5 border-left right-align text-bold"}>
                {checkNegative(total.MTDVarianceAmt).toLocaleString()}
              </td>
              <td className={"w-5 right-align text-bold"}>
                {checkNegative(total.YTDVarianceAmt).toLocaleString()}
              </td>
              <td className={"w-5 border-left right-align text-bold"}>
                {checkNegative(total.MTDVariancePerct, false).toLocaleString()}
              </td>
              <td className={"w-5 right-align border-right-dark text-bold"}>
                {checkNegative(total.YTDVariancePerct, false).toLocaleString()}
              </td>
              <td className={"w-10 border-left  border-bottom right-align text-bold"}>
                {checkNegative(total.CashOnHand).toLocaleString()}
              </td>
              <td className={"w-10 border-bottom border-left right-align text-bold"}>
                {checkNegative(total.InstalledKw).toLocaleString()}
              </td>
              <td className={"w-10  border-bottom border-left right-align text-bold"}>
                {checkNegative(total.LeasedCapacity).toLocaleString()}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default FinancialTable;
